import countries from './countries.json';
import email from './email.json';
import shopify from './shopify.json';
import translation from './translation.json';

export default { countries, email, shopify, translation };
